<snl-modal class="model__customize delete-subpool" *ngIf="iConfirmModal" [settings]="setting" (modalClose)="iConfirmModal = false"
    [type]="'small'" [open]="iConfirmModal">
    <div slot="heading">{{title}}</div>
    <div slot="modalContent" class="body-b1">You are about to take an irreversible action.</div>
    <div slot="modalContent" class="body-b1">
        <ng-container *ngIf="description">{{description}}</ng-container>
        <ng-template #default>Are you sure ?</ng-template>
    </div>
    <div slot="modalFooter">
        <snl-button size="small" (buttonClick)="action('yes')">Yes</snl-button>
        <snl-button size="small" type="secondary" (buttonClick)="action('no')">No</snl-button>
    </div>
</snl-modal>